import { WixHeadersValidationError } from './errors';
export function assertBoolean(key, value) {
    if (typeof value !== 'boolean') {
        throw new WixHeadersValidationError('boolean', key, value);
    }
}
export function assertString(key, value) {
    if (typeof value !== 'string') {
        throw new WixHeadersValidationError('string', key, value);
    }
}
//# sourceMappingURL=assert.js.map